// extracted by mini-css-extract-plugin
export default {"root":"PjPaitxy","fullyRevealed":"OSOEqH6_","placeholder":"cewWPjoO"};